import { __extends } from "tslib";
import * as React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { namespacedClassnames } from '../../common/namespace-classes';
import { matchPath, Switch } from 'react-router';
var orderPrefix = 'slide-order-';
var isSwitch = function (comp) {
    return comp && comp.type && comp.type === Switch;
};
var getChildOrder = function (child, fallback) {
    var key = child.key || '';
    var hasOvrOrder = key.indexOf(orderPrefix) !== -1;
    return hasOvrOrder ? parseInt(key.replace(orderPrefix, ''), 10) : fallback;
};
var getSwitchChildOrder = function (switchComp) {
    var found = -1;
    var routes = switchComp.props.children;
    if (!switchComp.props.location) {
        console.warn('Switch inside slide container must be provided with location as prop to infer direction');
    }
    var pathname = switchComp.props.location && switchComp.props.location.pathname;
    React.Children.forEach(routes, function (route, routeIdx) {
        var matches = matchPath(pathname, route && route.props);
        if (matches) {
            found = getChildOrder(route, routeIdx);
        }
    });
    return found;
};
var getOrder = function (children) {
    var found = -1;
    React.Children.forEach(children, function (child, idx) {
        if (child) {
            // if it's a switch we wanna know the order of the actual rendered route
            found = isSwitch(child) ? getSwitchChildOrder(child) : getChildOrder(child, idx);
        }
    });
    return found;
};
var getDirection = function (prev, curr) {
    if (curr > prev) {
        return 'right';
    }
    else if (curr < prev) {
        return 'left';
    }
    else {
        return 'none';
    }
};
var SlideContainer = /** @class */ (function (_super) {
    __extends(SlideContainer, _super);
    function SlideContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.transitionTime = 300;
        _this.lastOrder = -1;
        return _this;
    }
    SlideContainer.prototype.render = function () {
        var currOrder = getOrder(this.props.children);
        var direction = getDirection(currOrder, this.lastOrder);
        this.lastOrder = currOrder;
        return (React.createElement(CSSTransitionGroup, { className: namespacedClassnames('slide-container'), transitionName: "slide-" + direction, transitionAppearTimeout: this.transitionTime, transitionEnterTimeout: this.transitionTime, transitionLeaveTimeout: this.transitionTime }, this.props.children));
    };
    return SlideContainer;
}(React.PureComponent));
export { SlideContainer };
// tslint:disable-next-line:max-classes-per-file
var SlideItem = /** @class */ (function (_super) {
    __extends(SlideItem, _super);
    function SlideItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SlideItem.prototype.render = function () {
        return React.createElement("div", { className: 'item' }, this.props.children);
    };
    return SlideItem;
}(React.PureComponent));
export { SlideItem };
//# sourceMappingURL=slide-container.js.map